/**
 * Foundation tokens: 21 gray stops + 6 color families × 19 stops + 5 shadow primitives.
 * Consumed via the semantic surface (`tokens/Semantic/Semantic.ts`), not directly.
 * `--gray-0` / `--gray-1000` are mode-aware canvas/ink anchors; intermediate stops flip per mode in `PaletteEngine`.
 */
export type GrayStop =
  | '0'
  | '50'
  | '100'
  | '150'
  | '200'
  | '250'
  | '300'
  | '350'
  | '400'
  | '450'
  | '500'
  | '550'
  | '600'
  | '650'
  | '700'
  | '750'
  | '800'
  | '850'
  | '900'
  | '950'
  | '1000';
export type ColorStop =
  | '50'
  | '100'
  | '150'
  | '200'
  | '250'
  | '300'
  | '350'
  | '400'
  | '450'
  | '500'
  | '550'
  | '600'
  | '650'
  | '700'
  | '750'
  | '800'
  | '850'
  | '900'
  | '950';
export type ShadowStop = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type ColorFamily = 'brand' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export type GrayTokenName = `--gray-${GrayStop}`;
export type ColorTokenName = `--${ColorFamily}-${ColorStop}`;
export type ShadowTokenName = `--shadow-${ShadowStop}`;

export type FoundationTokenName = ColorTokenName | GrayTokenName | ShadowTokenName;

export type FoundationTokens = {
  [K in FoundationTokenName]: string;
};

export const GRAY_STOPS: readonly GrayStop[] = [
  '0',
  '50',
  '100',
  '150',
  '200',
  '250',
  '300',
  '350',
  '400',
  '450',
  '500',
  '550',
  '600',
  '650',
  '700',
  '750',
  '800',
  '850',
  '900',
  '950',
  '1000'
];

export const COLOR_STOPS: readonly ColorStop[] = [
  '50',
  '100',
  '150',
  '200',
  '250',
  '300',
  '350',
  '400',
  '450',
  '500',
  '550',
  '600',
  '650',
  '700',
  '750',
  '800',
  '850',
  '900',
  '950'
];

export const COLOR_FAMILIES: readonly ColorFamily[] = ['brand', 'accent', 'success', 'warning', 'danger', 'info'];

export const SHADOW_STOPS: readonly ShadowStop[] = ['xs', 'sm', 'md', 'lg', 'xl'];

export type PaletteFamily =
  | 'amber'
  | 'blue'
  | 'cyan'
  | 'emerald'
  | 'fuchsia'
  | 'gray'
  | 'green'
  | 'indigo'
  | 'lime'
  | 'neutral'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'red'
  | 'rose'
  | 'sky'
  | 'slate'
  | 'stone'
  | 'teal'
  | 'violet'
  | 'yellow'
  | 'zinc';

export const PALETTE_FAMILIES: readonly PaletteFamily[] = [
  'amber',
  'blue',
  'cyan',
  'emerald',
  'fuchsia',
  'gray',
  'green',
  'indigo',
  'lime',
  'neutral',
  'orange',
  'pink',
  'purple',
  'red',
  'rose',
  'sky',
  'slate',
  'stone',
  'teal',
  'violet',
  'yellow',
  'zinc'
];
